module.exports = __webpack_public_path__ + "img/coins-stacked-01.e7165aeb.svg";